<div
    class="loading-state"
    [class.loading-state--fullscreen]="fullscreen()"
    [class.loading-state--compact]="compact()"
    role="status"
    aria-live="polite"
    [attr.aria-busy]="true"
>
    <div class="loading-state__spinner" aria-hidden="true"></div>
    @if (message()) {
        <p class="loading-state__message">{{ message() }}</p>
    }
</div>
